import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-50">
          <i className="ri-mail-send-line text-primary-500 text-2xl"></i>
        </div>
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
          {contactData.title}
        </h2>
        <p className="text-foreground-500 text-sm md:text-base leading-relaxed max-w-xl mx-auto mb-4">
          {contactData.subtitle}
        </p>
        <p className="text-foreground-400 text-xs md:text-sm leading-relaxed max-w-xl mx-auto mb-8">
          {contactData.description}
        </p>

        <div className="inline-flex flex-col sm:flex-row items-center gap-3 bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 flex-shrink-0">
              <i className="ri-mail-line text-primary-500 text-lg"></i>
            </div>
            <span className="text-sm md:text-base font-medium text-foreground-800">
              {contactData.email}
            </span>
          </div>
          <span className="hidden sm:block w-px h-8 bg-background-200/70"></span>
          <a
            href={`mailto:${contactData.email}`}
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-medium px-6 py-2.5 rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-send-plane-line"></i>
            立即投稿
          </a>
        </div>

        <p className="mt-6 text-xs text-foreground-400">
          所有投稿均采用端到端加密传输，不记录 IP，不泄露身份
        </p>
      </div>
    </section>
  );
}